"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    fontFamily: 'Roboto',
    h1: {
        fontSize: 36,
        lineHeight: '46px',
        letterSpacing: 'normal',
        fontWeight: 500,
    },
    h2: {
        fontSize: 28,
        lineHeight: '38px',
        letterSpacing: 'normal',
        fontWeight: 500,
    },
    h3: {
        fontSize: 24,
        lineHeight: '32px',
        letterSpacing: 'normal',
        fontWeight: 500,
    },
    h4: {
        fontSize: 18,
        lineHeight: '26px',
        letterSpacing: 'normal',
        fontWeight: 500,
    },
    body1: {
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: 'normal',
    },
    body2: {
        fontSize: 14,
        lineHeight: '22px',
        letterSpacing: 'normal',
    },
    caption: {
        fontSize: 12,
        lineHeight: '22px',
        letterSpacing: 0.4,
        fontWeight: 'normal',
    },
};
